import { CheckAuthHandler, SendMessageHandler, StatusChangeHandler } from "../store/stateSchema";

let websocket_url = "ws://localhost:8000";

if (process.env.NODE_ENV === "production") {
  websocket_url = "wss://" + process.env.REACT_APP_HOST;
}

let ws: WebSocket | null = null; // WebSocket reference

const RECONNECT_DELAY = 1000; // Delay in milliseconds before reconnecting

let checkAuthHandler: CheckAuthHandler | null = null;

let sendMessageHandler: SendMessageHandler | null = null;

let statusChangeHandler: StatusChangeHandler | null = null;

const handleStatusChange = (status: boolean) => {
  statusChangeHandler?.(status);
};

const handleOpen = (event: Event): void => {
  handleStatusChange(true);
};

const handleMessage = (event: MessageEvent): void => {
  sendMessageHandler?.(event.data);
};

const handleError = (event: Event): void => {
  handleStatusChange(false);
};

const handleClose = (event: CloseEvent): void => {

  if (!event.wasClean) {
    handleStatusChange(false);

    if (localStorage.getItem('token')) {
      setTimeout(() => {
        connectWebSocket();  // Attempt to reconnect
      }, RECONNECT_DELAY);
    }
  }
};

const cleanUpWebSockets = (): void => {
  if (ws) {
    handleStatusChange(false);
    ws.removeEventListener('open', handleOpen);
    ws.removeEventListener('message', handleMessage);
    ws.removeEventListener('error', handleError);
    ws.removeEventListener('close', handleClose);

    if (ws.readyState === WebSocket.OPEN) {
      ws.close();
    }
  }
};

const connectWebSocket = () => {
  // Check if there's an existing WebSocket connection
  if (ws && ws.readyState === WebSocket.OPEN) {
    return;
  }

  checkAuthHandler?.();

  cleanUpWebSockets();

  ws = new WebSocket(`${websocket_url}/ws/chat/?token=${localStorage.getItem('token')}`);

  ws.addEventListener('open', handleOpen);
  ws.addEventListener('message', handleMessage);
  ws.addEventListener('error', handleError);
  ws.addEventListener('close', handleClose);
};

const unloadHandler = () => {
  wsAPI.stop(); // triggers ws.close() + cleanup
};

export const wsAPI = {
  start: (onCheckAuthHandler: CheckAuthHandler, onSendMessageHandler: SendMessageHandler, onStatusChangeHandler: StatusChangeHandler): void => {
    checkAuthHandler = onCheckAuthHandler;
    sendMessageHandler = onSendMessageHandler;
    statusChangeHandler = onStatusChangeHandler;
    connectWebSocket();
    window.addEventListener("beforeunload", unloadHandler);
  },
  stop: (): void => {
    cleanUpWebSockets();
    checkAuthHandler = null;
    sendMessageHandler = null;
    statusChangeHandler = null;
  },
  sendMessage: (message: any): void => {
    ws?.send(JSON.stringify(message));
  },
};
